<ul class="m-0 p-0">
  <li *ngFor="let node of nodes">
    <app-fs-tree-node
      [node]="node"
      (nodesHandler)="nodesEmitter($event)"
      (dropHandler)="onDrop($event)"
    ></app-fs-tree-node>
  </li>
</ul>
